import ApiService from "../api.services";

const InvoiceExcelService = {
  upload: async function (month, file) {
    let formData = new FormData();
    formData.append(`files[0]`, file.raw);
    console.log('upload', `/api/invoice.excel/upload?month=${month}`)
    const response = await ApiService.post(`/api/invoice.excel/upload?month=${month}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};

export default InvoiceExcelService;

export { InvoiceExcelService };
